import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Award, Users } from 'lucide-react';

// Datos de los beneficios
const benefits = [
  {
    id: 1,
    icon: <Shield size={40} />,
    title: 'Confianza y Seguridad',
    description: 'Todas nuestras propiedades están verificadas y cumplen con los más altos estándares de calidad y seguridad.'
  },
  {
    id: 2,
    icon: <Award size={40} />,
    title: 'Diseño Exclusivo',
    description: 'Seleccionamos propiedades con arquitectura distinguida y acabados premium para un estilo de vida superior.'
  },
  {
    id: 3,
    icon: <Users size={40} />,
    title: 'Asesoría Personalizada',
    description: 'Nuestro equipo de expertos le acompañará en todo el proceso para encontrar la propiedad perfecta.'
  }
];

// Componente para cada tarjeta de beneficio
const BenefitCard: React.FC<{
  benefit: typeof benefits[0];
  index: number;
}> = ({ benefit, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.2 }}
      className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow text-center"
    >
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 text-primary dark:text-secondary mb-6">
        {benefit.icon}
      </div>
      <h3 className="text-xl font-serif font-bold text-dark dark:text-light mb-3">
        {benefit.title}
      </h3>
      <p className="text-gray-600 dark:text-gray-300">
        {benefit.description}
      </p>
    </motion.div>
  );
};

const Benefits: React.FC = () => {
  return (
    <section id="benefits" className="section bg-gray-50 dark:bg-gray-900">
      <div className="container">
        <div className="text-center mb-12">
          <motion.h2
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="text-3xl md:text-4xl font-serif font-bold text-dark dark:text-light mb-4"
          >
            Nuestros Valores
          </motion.h2>
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="w-24 h-1 bg-secondary mx-auto mb-6"
          ></motion.div>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="text-gray-600 dark:text-gray-300 max-w-2xl mx-auto"
          >
            En LuxuryEstates nos distinguimos por ofrecer un servicio excepcional basado en estos principios fundamentales.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <BenefitCard key={benefit.id} benefit={benefit} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;